import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { useMemo } from 'react';
export function MediumTabs(props) {
    const { pages } = props;
    const tab_pages = useMemo(() => pages.map((page, i) => (_jsx(Box, { display: page.visible ? undefined : 'none', height: "100%", children: page.content }, i))), [pages]);
    return (_jsx(Box, { "data-tooltip": "device-medium-tabs-container", height: "100%", width: "100%", display: "flex", flexDirection: "column", flexWrap: "nowrap", overflow: "auto", children: tab_pages }));
}
